// extracted by mini-css-extract-plugin
export var footer = "_qy-0";
export var inherit = "_qy-1";
export var input = "_qy-2";
export var modalContent = "_qy-3";
export var quillEditor = "_qy-4";
export var subtitle = "_qy-5";